module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-9682.908ac15b.jpg";